import jsrsasign from 'jsrsasign';
import store from '@/store';

import router from '@/router';
import { urls } from '@/util/config';

const JWT_ITEM_NAME = 'jwt';
const USER_ID_ITEM_NAME = 'userId';
const LAST_LOGIN_ITEM_NAME = 'lastLogin';

export default {
    // Send a request to the login URL and save the returned JWT
    login(context, credentials, redirectRouteName) {
        const loginConfig = {
            headers: {
                'Content-Type': 'application/json',
            },
        };

        store.commit('setLoginNotAuth', false);
        store.commit('setLoginFailed', false);

        context.$http.post(urls.AUTH_URL, credentials, loginConfig).then((response) => {
            if (response.status === 200) {
                const token = response.body.access_token;
                const id = response.body.user_id;
                const lastLogin = response.body.last_login;

                window.localStorage.setItem(JWT_ITEM_NAME, token);
                window.localStorage.setItem(USER_ID_ITEM_NAME, id);
                window.localStorage.setItem(LAST_LOGIN_ITEM_NAME, lastLogin);

                // TODO: send url for last login update /lastloong/{userid}
                store.dispatch('login');
                store.commit('setTimedOut', false);
                store.commit('setLoggingIn', false);

                if (redirectRouteName) {
                    router.push({
                        name: redirectRouteName,
                    });
                }
            }
        }).catch((e) => {
            if (e.status === 401) {
                store.commit('setTimedOut', false);
                store.commit('setLoggingIn', false);
                store.commit('setLoginNotAuth', true);
            } else {
                store.commit('setTimedOut', false);
                store.commit('setLoggingIn', false);
                store.commit('setLoginFailed', true);
            }
        });
    },

    // // To log out, we just need to remove the token
    logout() {
        localStorage.removeItem(JWT_ITEM_NAME);
        localStorage.removeItem(USER_ID_ITEM_NAME);
        localStorage.removeItem(LAST_LOGIN_ITEM_NAME);
        store.dispatch('logout');

        router.push({
            name: 'Login',
        });
    },
    /**
     * @return Boolean
     * Return true if there is a token and it has a valid date.
     */
    checkAuth() {
        const jwt = localStorage.getItem(JWT_ITEM_NAME);

        if (jwt) {
            const payloadObj = jsrsasign.jws.JWS.parse(jwt).payloadObj;
            const exp = payloadObj.exp;

            // exp time is seconds from epoch. Date takes milliseconds so convert
            const expiryDate = new Date(exp * 1000);

            if (expiryDate > new Date()) {
                store.dispatch('login');
                return true;
            }
        }

        store.dispatch('logout');
        return false;
    },

    // // The object to be passed as a header for authenticated requests
    getAuthHeader() {
        return {
            Authorization: `JWT ${localStorage.getItem(JWT_ITEM_NAME)}`,
        };
    },
};



// WEBPACK FOOTER //
// ./src/util/auth.js